export default __webpack_public_path__ + "static/media/avatar-preview.07b6dac5.jpg";